module.exports = __webpack_public_path__ + "img/sq5m_02.7f48c508.jpg";